var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm._m(0),
      _c("BTable", {
        attrs: { data: _vm.overtimeWithIndex, columns: _vm.columns },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c(
                  "BTableColumn",
                  {
                    staticClass: "limit-150",
                    attrs: { field: "Days", internal: "" }
                  },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "days",
                            placeholder: "Días",
                            type: "number",
                            min: "0",
                            max: "15",
                            value: props.row.days,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(_vm.id, "days", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "hoursType", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c(
                          "BSelect",
                          {
                            staticClass: "is-fullwidth",
                            attrs: {
                              name: "hoursType",
                              placeholder: "Selecciona el tipo",
                              value: props.row.hoursType,
                              disabled: _vm.loading,
                              loading: _vm.loading,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(_vm.id, "hoursType", $event)
                              }
                            }
                          },
                          _vm._l(_vm.hourTypeCatalog, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "ovetime", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "ovetime",
                            placeholder: "Horas Extra",
                            type: "number",
                            min: "0",
                            value: props.row.ovetime,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(_vm.id, "ovetime", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "amount", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "amount",
                            placeholder: "Selecciona el tipo",
                            type: "number",
                            min: "0",
                            step: "0.01",
                            value: props.row.amount,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(_vm.id, "amount", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container is-flex" }, [
      _c("h4", { staticClass: "title is-centered is-4 has-text-primary" }, [
        _vm._v("\n      Horas Extra\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }